export const GENDER = {
  MALE: "male",
  FEMALE: "female",
  MIXED: "mixed",
} as const;
